import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2, Clock, ShieldAlert } from 'lucide-react';

export default function InstructorProtectedRoute() {
  const { currentUser, isInstructor, isAdmin, instructorStatus, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-zinc-950">
        <Loader2 className="w-10 h-10 animate-spin text-primary-600" />
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (!isInstructor) {
    if (isAdmin) {
      return <Navigate to="/admin/overview" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  // Instructor-specific Status Gates
  if (instructorStatus === 'incomplete') {
    return <Navigate to="/instructor-onboarding" replace />;
  }

  if (instructorStatus === 'pending') {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 dark:bg-zinc-950 p-6">
        <div className="max-w-md w-full bg-white dark:bg-zinc-900 border border-slate-200 dark:border-white/10 shadow-2xl rounded-3xl p-10 text-center animate-in fade-in zoom-in duration-700 relative overflow-hidden group">
          {/* Subtle Glow */}
          <div className="absolute inset-x-0 -top-10 h-32 bg-amber-500/10 blur-3xl rounded-full scale-150 pointer-events-none"></div>

          <div className="w-24 h-24 bg-amber-100 dark:bg-amber-500/20 text-amber-500 dark:text-amber-400 rounded-full flex items-center justify-center mx-auto mb-6 border-4 border-white dark:border-zinc-800 shadow-md">
            <Clock className="w-10 h-10" />
          </div>
          <h2 className="text-3xl font-black text-slate-900 dark:text-white mb-3">حسابك قيد المراجعة</h2>
          <p className="text-slate-500 dark:text-zinc-400 text-lg font-medium leading-relaxed mb-8">
            أهلاً بك في مدرسة لُباب. لقد استلمنا طلبك للانضمام كمدرب، وهو الآن قيد المراجعة من قِبل الإدارة. سيتم إخطارك فور تفعيل حسابك.
          </p>
          <button 
            onClick={() => window.location.href = '/'}
            className="w-full py-4 bg-slate-900 hover:bg-black dark:bg-white/10 dark:hover:bg-white/20 text-white font-bold rounded-xl transition-all"
          >
            العودة للرئيسية
          </button>
        </div>
      </div>
    );
  }

  if (instructorStatus === 'suspended') {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 dark:bg-zinc-950 p-6">
        <div className="max-w-md w-full bg-white dark:bg-zinc-900 border border-red-200 dark:border-red-900/30 shadow-2xl rounded-3xl p-10 text-center relative overflow-hidden">
             <div className="absolute inset-x-0 -top-10 h-32 bg-red-500/10 blur-3xl rounded-full scale-150 pointer-events-none"></div>
             
             <div className="w-24 h-24 bg-red-100 dark:bg-red-500/20 text-red-500 dark:text-red-400 rounded-full flex items-center justify-center mx-auto mb-6 border-4 border-white dark:border-zinc-800 shadow-md">
                <ShieldAlert className="w-10 h-10" />
             </div>
             <h2 className="text-3xl font-black text-slate-900 dark:text-white mb-3">حساب موقوف</h2>
             <p className="text-slate-500 dark:text-zinc-400 text-lg font-medium leading-relaxed">
               تم إيقاف صلاحيات التدريس الخاصة بك. يرجى التواصل مع الدعم الفني للإدارة.
             </p>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
